import { toast, type Id, ToastOptions, ToastContent } from "react-toastify";

let lastToastId: Id | null = null;

function show(content: ToastContent, options?: ToastOptions) {
  if (lastToastId) toast.dismiss(lastToastId);  
  lastToastId = toast(content, options);
  return lastToastId;
}

show.success = (content: ToastContent, options?: ToastOptions) => show(content, { ...options, type: "success" });
show.error = (content: ToastContent, options?: ToastOptions) => show(content, { ...options, type: "error" });
show.info = (content: ToastContent, options?: ToastOptions) => show(content, { ...options, type: "info" });
show.warning = (content: ToastContent, options?: ToastOptions) => show(content, { ...options, type: "warning" });
show.warn = show.warning;
show.dark = (content: ToastContent, options?: ToastOptions) => show(content, { ...options, theme: "dark" });

export default show;
